import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserContextService } from '../services/user-context.service';

/**
 * Allows only manager or admin (e.g. create internal task wizard).
 */
export const managerOrAdminGuard: CanActivateFn = async () => {
  const userContext = inject(UserContextService);
  const router = inject(Router);

  if (!userContext.loaded()) {
    await userContext.initialize();
  }
  const r = userContext.role();
  if (r === 'manager' || r === 'admin') {
    return true;
  }
  return router.createUrlTree(['/app/dashboard']);
};
